<ng-container *ngIf="composant">
    <!-- Chemin actuel dans l'arbre -->
    <p class="address">
        {{displayedPath}} 
    </p>
    <!-- Element affiché -->
    <p class="current">{{composant.label}}</p>
    <!-- Type Zone, Composant, Symptome : affichage de la liste des enfants sous forme de lien -->
    <div *ngIf="composant.type == 'Elément' && composant.children_type != 'Réponse'">
        <ul >
            <li *ngFor="let child of children" (click)="addToSelection(child)">{{child.label}} 
                <mat-icon *ngIf="hasBeenExplored(child)">check_circle</mat-icon> 
            </li>
        </ul>
        <span *ngIf="composant.children_id.length < 1">Aucun élément suivant à afficher</span>
    </div>
    <!-- Type Question : affichage de la liste des enfants sous forme de réponses -->
    <div *ngIf="composant.children_type == 'Réponse'">
        <div class="flex2" *ngFor="let child of children">
            
            <strong>{{child.label}}</strong>
            
            <label [for]="child.id+'W'">Client</label>
            <input type="radio" class="rbutton" (change)="handleRadio($event)" [id]="child.id+'W'" name="answergroup">

            <label [for]="child.id+'S'">Technicien</label>
            <input type="radio" class="rbutton" (change)="handleRadio($event)" [id]="child.id+'S'" name="answergroup">
        <hr/>    
        </div>
        <!-- Commentaire de l'agent SAV -->
        <div>
            <textarea style="resize: none;" cols="50" rows="4" placeholder="Commentaire..." [(ngModel)]="currentComment"></textarea>
        </div>
             
    </div>
    <!-- Actions -->
    <div class="flex2">
        <div class="end">
            <button  class="btn btn-resolved" *ngIf="showSolvedButton"  (click)="resolvedPanne(true)">Résolu</button>
        </div>      
        <div class="next"> 
            <button class="btn btn-next" (click)="nextVerif()" *ngIf="showNextButton && composant.type != 'Solution'">Suivant</button>
        </div>
        <div class="next">
            <button  class="btn btn-ticket" *ngIf="showSolvedButton"  (click)="resolvedPanne(false)">Ticket Niveau Supérieur</button>
        </div>      

    </div>

</ng-container>